import { createFileRoute } from '@tanstack/react-router'
import GuidesManagement from '@/components/Guides'

export const Route = createFileRoute('/_authenticated/products/guides/')({
  component: () => <GuidesManagement />,
})
